var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAva2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1099D6;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#851619;}\r\n\t.st2{fill:#EDD9B4;}\r\n\t.st3{fill:#DCC5A1;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#BC9F82;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:#D43329;}\r\n\t.st7{fill:#CA3029;}\r\n\t.st8{fill:#A82623;}\r\n\t.st9{fill:#342214;}\r\n\t.st10{fill:#1B75BC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.3,349l-0.2,0.2l40.7,63.1l27.6-25.1l0,0l0,0l8.6-7.8l0.4,0.4l35.8,32.5l40.7-63.1l-0.2-0.2   c29.2,18.7,67.2,29.1,99.5,36.3c2.4,0.5,4.6,1.2,6.7,2c20.8-33.2,32.9-72.5,32.9-114.5C471.7,153.6,375.1,57,256,57   C136.9,57,40.3,153.6,40.3,272.8c0,42.1,12.1,81.3,32.9,114.5c2.1-0.8,4.4-1.4,6.7-2C112.1,378.1,150.2,367.7,179.3,349z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.4,287.1c-17.6-181,32.1-263.6,135.4-263.6c103.3,0,158.5,93.6,133.2,263.6   C311.7,332.4,187.1,324.9,120.4,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,197.3v186.2c16.1-1.9,31.1-17.5,44.1-34.5v-108C300.1,211.9,278,197.3,256,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M211.9,241.1v108c15.1,27.5,30,36.2,44.1,34.5V197.3C234,197.3,211.9,211.9,211.9,241.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M300.1,236.7V309c-16.7,13-32.8,20.4-44.1,20.4c-11.3,0-27.4-7.3-44.1-20.4v-72.3   C211.9,178.4,300.1,178.4,300.1,236.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 256,
    cy: 379.4,
    r: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.7,42.9c-79.4,0-116.7,70.8-112.6,132.1c-5-3.4-10.1-4.5-14.4-2.7c-9.2,4-11.2,20.1-4.3,36.1     c6.9,16,19.9,25.7,29.1,21.7c1.6-0.7,2.9-1.7,4.1-3.1c24.9,50.7,73.4,84.3,98.1,84.3h0L255.7,42.9L255.7,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M383.3,172.3c-4.5-1.9-9.9-0.6-15,3.1c4.3-61.5-33-132.5-112.6-132.5v268.5c24.8,0,73.5-33.8,98.4-84.8     c1.2,1.5,2.7,2.7,4.5,3.5c9.2,4,22.3-5.8,29.1-21.7C394.5,192.4,392.6,176.3,383.3,172.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.5,90.6c46.4,29.6,49.1,69.3,51,100C388.4,164.6,390.2,72.6,316.5,90.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.3,90.6c-46.4,29.6-49.1,69.3-51,100C125.4,164.6,123.6,72.6,197.3,90.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138,118.2c4.1-132.3,234.4-119.9,235.5,0c-23.7,5.7-52.4,9.1-82.3,10.5c-1.7-11.9-5.1-27.1-11.1-46.4    c-3.2,9.1-5.3,29.1-6.3,46.9c-17.5,0.4-35,0.1-52-0.7c-1-17.5-3.1-36.5-6.2-45.4c-5.7,18.2-9.1,32.8-10.8,44.3    C179.4,125.6,156.2,122.4,138,118.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M268.6,261.7c0,0,0.5,8-13.2,8c-4,0-13-1.7-13-7.8C250.5,263.8,260.1,264.3,268.6,261.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M260.7,258.4c3,0.4,8.3,3.2,7.9,3.3c-8.5,2.6-18.1,2.1-26.1,0.2c-0.1,0-0.2,0-0.2-0.1     c2.7-1.1,6.3-3.4,8.9-3.2c1.4,0.1,3.1,1.2,4.4,1.2C257.5,259.8,258.7,258.1,260.7,258.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M238,260.7c10.2,4.3,24.5,4.7,34.6-0.2c0.2-0.1,0.1-0.5-0.2-0.4C260.4,263.9,250.3,263.2,238,260.7     C238,260.6,237.9,260.6,238,260.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M208,178.3c6.5,0,11.8,6,11.8,13.4c0,7.4-5.3,13.4-11.8,13.4c-6.5,0-11.8-6-11.8-13.4    C196.2,184.3,201.5,178.3,208,178.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M304,178.3c6.5,0,11.8,6,11.8,13.4c0,7.4-5.3,13.4-11.8,13.4c-6.5,0-11.8-6-11.8-13.4    C292.2,184.3,297.5,178.3,304,178.3"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "256.4,379.8 256,379.4 247.4,387.2 256,379.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M247.4,488.3V387.2l-27.6,25.1l-40.7-63.1l0.2-0.2c-29.2,18.7-67.2,29.1-99.5,36.3c-2.4,0.5-4.6,1.2-6.7,2   C109.9,445.8,173.9,485.4,247.4,488.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M332.7,349l0.2,0.2l-40.7,63.1l-35.8-32.5l8.2,7.4v101.1c73.5-2.9,137.5-42.5,174.3-101   c-2.1-0.8-4.4-1.4-6.7-2C399.9,378.1,361.8,367.7,332.7,349z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M332.7,349l-32.6-29.9L256,379.4l0,0l0,0l0,0l0,0l-44.1-60.3L179.3,349l-0.2,0.2l40.7,63.1l27.6-25.1v101.1   c2.8,0.1,5.7,0.2,8.6,0.2c0,0,0,0,0,0c2.9,0,5.7-0.1,8.6-0.2V387.2l27.6,25.1l40.7-63.1L332.7,349z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "247.4,387.2 247.4,387.2 247.4,387.2  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAva2);
export default __webpack_public_path__ + "static/media/ava2.0b0566736e9db85dcc73da63cbe89992.svg";
export { ForwardRef as ReactComponent };